class FeatherIcon extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback();
    this.initialiseIcon();
  }

  initialiseIcon() {
    if (window.feather && this.hasAttribute("data-feather")) {
      const iconName = this.getAttribute("data-feather");

      if (feather.icons[iconName]) {
        const svgString = feather.icons[iconName].toSvg({ 'stroke-width': 1.5, stroke: 'currentColor' });
        this.innerHTML = svgString
      } else {
        console.warn(`Feather icon "${iconName}" does not exist.`);
      }
    }
  }
}

if (!customElements.get("feather-icon")) {
  customElements.define("feather-icon", FeatherIcon);
}
